import { create } from '@civic/prove-icp-principal';
import {
  Chain,
  ICPWalletAdapter,
  SignatureMethod,
  Wallet,
  ICPWalletSignedProofOptions,
} from '../types';
import { windowEventListener, EventListener } from './eventListener';
import { RemoteWallet } from './remote';
const TIMEOUT = 60 * 1000;

/**
 *
 * @param wallet the ICP wallet adapter
 * @returns {Wallet} a wallet object that can be used to sign a proof
 */
export const LocalICPWallet = (
  wallet: ICPWalletAdapter,
  options?: ICPWalletSignedProofOptions
): Wallet => ({
  getPublicKey: () => Promise.resolve(wallet.principal),
  getDid: () => Promise.resolve(`did:icp:v0:${wallet.principal}`),
  signProof: async (message: string) => {
    const { derivationOrigin, url } = options || {};
    const proof = await create({ message, derivationOrigin }, url);
    return {
      proof,
      chain: Chain.ICP,
      signatureMethod: SignatureMethod.MESSAGE,
      options: {},
    };
  },
  signMessage: async () => {
    throw new Error(`Not implemented`);
  },
  chain: Chain.ICP,
});

/**
 *
 * @param timeout timeout in milliseconds waiting for the remote wallet to receive a response
 * @param eventListener the event listener to use for the remote wallet
 * @returns {Wallet}
 */
export const RemoteICPWallet = ({
  timeout = TIMEOUT,
  eventListener = windowEventListener(),
  instanceId,
  debug,
}: {
  timeout: number;
  eventListener?: EventListener;
  instanceId: string;
  debug?: boolean;
}): Wallet => {
  const remoteWallet = RemoteWallet({
    chain: Chain.ICP,
    eventListener,
    timeout,
    instanceId,
    debug,
  });

  return remoteWallet;
};
